import styled from 'styled-components';

export const StyledAppBar = styled.span`
  .header-text {
    margin-top: 10px;
    margin-bottom: 10px;
    margin-left: 8px;
    font-weight: bold;
  }
`;
